const imageRotator = {
	init: function ($slider) {
		let target = $slider.el.dataset.rotateTarget || '',
			$rotator = document.getElementById(target),
			$wrapper = $rotator.querySelector('.images-wrapper'),
			activeIndex = $slider.activeIndex;

		let rotate = activeIndex * 90

		$($wrapper).css({ transform: 'translateY(-50%) rotate(-' + rotate + 'deg)' })

		let $images = $rotator.querySelectorAll('.image-area');
		if ($images.length) {
			Array.from($images).map(function (item) {
				return item.classList.remove('active');
			});

			for (const $image of $images) {
				let index = parseInt($image.dataset.index);
				if (index === activeIndex) {
					$image.classList.add('active');
				}

				if (index === 1) {
					$($image).css({ transform: 'translateX(-50%) rotate('+ rotate +'deg)' })
				}

				if (index === 2) {
					$($image).css({
						transform: 'translateX(0) translateY(-50%) rotate(180deg)',
					})
				}

				if (index === 3) {
					$($image).css({ transform: 'translateY(0) translateX(-50%) rotate(270deg)' })
				}
			}
		}
	}
}

export default imageRotator
